'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.noAuth = exports.hublessAuth = undefined;

var _core = require('hub-http/middlewares/core');

var core = _interopRequireWildcard(_core);

var _hubapi = require('hub-http/middlewares/hubapi');

var hubapi = _interopRequireWildcard(_hubapi);

var _debug = require('hub-http/middlewares/debug');

var debug = _interopRequireWildcard(_debug);

var _noAuthApiClient = require('hub-http/clients/noAuthApiClient');

var _noAuthApiClient2 = _interopRequireDefault(_noAuthApiClient);

var _index = require('hub-http/index');

var _promiseClient = require('hub-http/adapters/promiseClient');

var _promiseClient2 = _interopRequireDefault(_promiseClient);

var _app = require('./app');

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var withCsrf = function withCsrf(options) {
  var state = _app2.default.store.getState();
  var csrf = state.auth && state.auth.csrfToken;
  if (csrf) {
    return core.header('X-HubSpot-CSRF-hubspotapi', csrf)(options);
  }
  return options;
};

var hublessAuth = exports.hublessAuth = (0, _promiseClient2.default)((0, _index.createStack)(core.services, hubapi.defaults, debug.allowTimeoutOverride, core.jsonBody, core.httpsOnly, hubapi.hubapi, withCsrf, core.withQuery, debug.rewriteUrl, hubapi.timeoutInQuery, core.reportOptionsError, hubapi.retryOnError, core.validateStatus, core.jsonResponse));

var noAuth = exports.noAuth = _noAuthApiClient2.default;


//////////////////
// WEBPACK FOOTER
// ./js/http.js
// module id = 167
// module chunks = 177